import { Injectable } from "@angular/core";
import { StateService } from "@core-services/state.service";
import { Observable } from "rxjs";
import { LaunchpadAsset } from "@modules/launchpad/domain/entities/launchpad-asset";
import { Dictionary } from "@helpers/types";
import { Tradable } from "@models/interfaces/tradable";
import { Point } from "@models/point";

export interface LaunchpadState {
	assets: LaunchpadAsset[];
	newsletter_is_subscribed?: boolean;
	bestVipLevel?: number;
	error: boolean;

	// dictionaries are all indexed by asset id
	price?: Dictionary<number>;
	change?: Dictionary<number>;
	tradable?: Dictionary<Tradable>; // needed for charts x.x
	chartData?: Dictionary<Point[]>;
}

const initialState: LaunchpadState | null = null;

@Injectable({
	providedIn: "root"
})
export class LaunchpadStateService extends StateService<LaunchpadState> {
	constructor() {
		super(initialState);
	}

	public getState$(): Observable<LaunchpadState> {
		return this.select((state) => state);
	}

	public updateState(model: LaunchpadState): void {
		this.setState(model);
	}

	public updateNewsletterSub(subscribed: boolean): void {
		this.setState({
			...this.state,
			newsletter_is_subscribed: subscribed
		});
	}

	public updatAssetSub(id: number, subscribed: boolean): void {
		const assets = [...this.state.assets];
		assets.find((a) => a.id === id).is_subscribed = subscribed;

		this.setState({
			...this.state,
			assets
		});
	}

	public setError(errorState: boolean): void {
		this.setState({
			...this.state,
			error: errorState
		});
	}

	public updateTradableData(
		tradables: Dictionary<Tradable>,
		prices: Dictionary<number>,
		changes: Dictionary<number>
	): void {
		this.setState({
			...this.state,
			tradable: tradables,
			price: prices,
			change: changes
		});
	}
}
